import '../components/innerpages/innerpages.scss'

import React from 'react';
import { Helmet } from 'react-helmet';

import CustomJewelry from '../components/innerpages/custom/CustomJewelry';

function custom() {
  return (
    <>
      <Helmet>
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <div className="inner-pages-style1 s-project-pg-style1">
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <CustomJewelry />
        </div>
      </div>
    </>
  );
}

export default custom;